'use strict';

exports.__esModule = true;
exports.getVisibleCalendarDays = undefined;

var _constants = require('./constants');

/**
 * Returns the number of visible calendar days, based on the viewport width,
 * used for different calculations.
 * @return {number} The number of visible calendar days.
 */
var getVisibleCalendarDays = exports.getVisibleCalendarDays = function getVisibleCalendarDays() {
	if (typeof window === 'undefined' || window.innerWidth <= _constants.MOBILE_LARGE_WIDTH) {
		return _constants.MOBILE_CALENDAR_DAYS;
	}

	if (window.innerWidth <= _constants.TABLET_WIDTH) {
		return _constants.TABLET_CALENDAR_DAYS;
	}

	return _constants.LAPTOP_CALENDAR_DAYS;
};